import PropTypes from 'prop-types';

import './Spinner.scss';

/**
 * @param root0
 * @param root0.className
 * @returns {JSX} Spinner
 */
function Spinner({ className }) {
    let classes = className ? `${className} ` : '';
    classes += 'spinner';

    return (
        <div className={classes} data-cy='spinner'>
            <svg className='circular' viewBox='25 25 50 50'>
                <circle className='path' cx='50' cy='50' r='20' fill='none' strokeWidth='2' strokeMiterlimit='10' />
            </svg>
        </div>
    );
}
Spinner.propTypes = {
    className: PropTypes.string
};

export default Spinner;